import Vue from 'vue';
import Vuex from 'vuex';
import { address } from './modules/address';
import { invoice } from './modules/invoice';
import { home } from './modules/home';
import { card } from './modules/card';
import { user } from './modules/user';
import { order } from './modules/order';
import { search } from './modules/search';
import { equipment } from './modules/equipment';
import { notifys } from './modules/notifys';
import { white } from './modules/whiteS';
Vue.use(Vuex);
var store = {
  state: {
    version: '1.0.0'
  },
  modules: {
    address: address,
    invoice: invoice,
    home: home,
    card: card,
    user: user,
    order: order,
    search: search,
    notifys: notifys,
    equipment: equipment,
    white: white
  }
};
export default new Vuex.Store(store);